import React, { useEffect, useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import Input from "../../templates/Input";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import SpinerLoading from "../../../common/Loading/SpinerLoading";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";
import ManditoryStar from "../../templates/ManditoryStar";

const UserForm = () => {
  const params = useParams()
  console.log(params?.id,"para,");
  const id = params ?.id
  const [userData, setUserData] = useState({
    username: "",
    email: "",
    password: "",
    phone: "",
    role: "",

    usernameStatus: "unchecked",
    emailStatus: "unchecked",
    passwordStatus: "unchecked",
    phoneStatus: "unchecked",
    roleStatus: "unchecked",
  });
  const [showPassword, setShowPassword] = useState(false);

  const roleOption = [
    {
      id: 1,
      role: "Admin",
    },
    {
      id: 2,
      role: "View",
    },
    {
      id: 3,
      role: "Editer",
    },
  ];
  const navigate = useNavigate();
  const handleChange = (e) => {
    let newdata = { ...userData };

    if (e.target.name == "email") {
      const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (gmailRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e.target.name == "password") {
      const allCharactersLengthRegex = new RegExp("^.{8,15}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e.target.name == "username") {
      const allCharactersLengthRegex = new RegExp("^.{2,15}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e.target.name == "role") {
      const allCharactersLengthRegex = new RegExp("^.{1,15}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e.target.name == "phone") {
      const allCharactersLengthRegex = new RegExp("^.{10}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }
    newdata[e.target.name] = e.target.value;
    setUserData(newdata);
  };

  const checkSubmit = () => {
    let status = true;

    if (
      userData.emailStatus == "success" &&
      userData.passwordStatus == "success" &&
      userData.phoneStatus == "success"
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}register`, values);
    },
  });
 const { data } = useQuery({
    queryKey: "getsingleFaq",
    queryFn: () =>
      axios.get(`${BASEURL}user/${id}`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      console.log(response,"res");
      
      // setFaqData({
      //   question: response?.question,
      //   answer: response?.answer,
      //   category: response?.category,

      //   questionStatus: "success",
      //   answerStatus: "success",
      //   categoryStatus: "success",
      // });
    },
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    const values = {
      username: userData.username,
      email: userData.email,
      password: userData.password,
      phone: userData.phone,
      // role: userData.role,
    };
    mutation.mutate(values);
  };
  useEffect(() => {
    if (mutation.isSuccess) {
      console.log("succ");

      setUserData({
        username: "",
        email: "",
        password: "",
        phone: "",
        role: "",

        usernameStatus: "unchecked",
        emailStatus: "unchecked",
        passwordStatus: "unchecked",
        phoneStatus: "unchecked",
        roleStatus: "unchecked",
      });
      Swal.fire({
        title: "User created successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/user");
      });
    } else if (mutation.isError) {
      console.log(mutation);

      Swal.fire({
        title: mutation.error.response.data.message,
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      });
    }
  }, [mutation.data, mutation.isSuccess, mutation.isError]);
  return (
    <div>
      <AdminTabelHeader title={`${id?"Edit":"Add"} User`} btnStatus={false} />
      {mutation.isLoading && <TraingleLoading />}

      <div className="p-4">
        <div className="grid grid-cols-3 gap-4">
          <div>
            <ManditoryStar title={"User Name"} />

            <input
              name="username"
              value={userData.username}
              className={`input ${
                userData.usernameStatus == "success"
                  ? "input-success"
                  : userData.usernameStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              type="text"
              placeholder="Enter your name"
              onChange={(e) => handleChange(e)}
            />
            {userData.usernameStatus == "error" && (
              <p className="text-sm font-semibold text-speed-red">
                Username should be a minimum of 2 and a maximum of 15
                characters.
              </p>
            )}
          </div>
          <div>
            <ManditoryStar title={"Email"} />

            <input
              name="email"
              value={userData.email}
              className={`input ${
                userData.emailStatus == "success"
                  ? "input-success"
                  : userData.emailStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              type="text"
              placeholder="Enter your Email"
              onChange={(e) => handleChange(e)}
            />
            {userData.emailStatus == "error" && (
              <p className="text-sm font-semibold text-speed-red">
                Email Invalid
              </p>
            )}
          </div>
          <div>
            <ManditoryStar title={"Phone Number"} />
            <input
              name="phone"
              value={userData.phone}
              className={`input ${
                userData.phoneStatus == "success"
                  ? "input-success"
                  : userData.phoneStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              type="text"
              placeholder="Enter your Phone number"
              onChange={(e) => handleChange(e)}
            />
            {userData.phoneStatus == "error" && (
              <p className="text-sm font-semibold text-speed-red">
                Phone number should be 10 digits.
              </p>
            )}
          </div>
          <div className="relative">
            <ManditoryStar title={"Password"} />
            <input
              name="password"
              value={userData.password}
              className={`input relative ${
                userData.passwordStatus == "success"
                  ? "input-success"
                  : userData.passwordStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              type={showPassword ? "text" : "password"}
              placeholder="Enter your Password"
              onChange={(e) => handleChange(e)}
            />
            {showPassword ? (
              <EyeIcon
                onClick={() => setShowPassword(false)}
                className="w-5 h-5 absolute right-2 bottom-4"
              />
            ) : (
              <EyeSlashIcon
                onClick={() => setShowPassword(true)}
                className="w-5 h-5 absolute right-2 bottom-4"
              />
            )}
            {userData.passwordStatus == "error" && (
              <p className="text-speed-red font-medium text-sm mt-1">
                Your password should be at least 8 characters long
              </p>
            )}
          </div>
          {/* <div>
            <label className="label">Role</label>
            <select
              name="role"
              value={userData.role}
              onChange={(e) => handleChange(e)}
              className={`input ${
                userData.roleStatus == "success"
                  ? "input-success"
                  : userData.roleStatus == "error"
                  ? "input-error"
                  : ""
              }`}
            >
              <option value="">Select Role</option>
              {roleOption?.map((v, i) => (
                <option key={i} value={v.id}>
                  {v.role}
                </option>
              ))}
            </select>
          </div> */}
        </div>
        <div className="flex justify-end my-4 ">
          <button
            onClick={() => navigate(-1)}
            // disabled={checkSubmit()}
            className={"formSubmit mr-8 cursor-pointer "}
          >
            Cancel
          </button>
          <button
            onClick={(e) => handleSubmit(e)}
            disabled={checkSubmit()}
            className={`formSubmit   ${
              checkSubmit() ? "cursor-not-allowed" : "cursor-pointer"
            } `}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserForm;
